import { isRichTextEmpty } from "../../../components/RichTextEditor/rich-text-html.ts"

export const NOTES_MAX_VISIBLE_LENGTH = 511
export const NOTES_MAX_IMAGES = 3

const parse = (html: string) =>
  new DOMParser().parseFromString(html, "text/html").body

/**
 * The characters the customer reads, the rule `ezbuild_back` enforces: the
 * text nodes joined with nothing between blocks, so markup, link addresses
 * and images never count.
 */
export const visibleNotesLength = (html?: string | null): number =>
  html ? (parse(html).textContent ?? "").length : 0

export const notesImageCount = (html?: string | null): number =>
  html ? parse(html).querySelectorAll("img").length : 0

/** An editor left empty reads as no notes at all, never as `<p></p>`. */
export const normaliseNotes = (html?: string | null): string =>
  !html || isRichTextEmpty(html) ? "" : html
